// 임시 이미지
import ProductJpg from "./assets/img/picture/product.jpg";
import product_01 from "./assets/img/picture/product_01.jpg";
import product_02 from "./assets/img/picture/product_02.jpg";
import product_03 from "./assets/img/picture/product_03.jpg";
import product_04 from "./assets/img/picture/product_04.jpg";

// 제품리스트
const ProductData = [
    {
        id: 0,
        productImg: ProductJpg,
        itemName: "Filaments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 1,
        productImg: ProductJpg,
        itemName: "Filaments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 2,
        productImg: product_01,
        itemName: "A530",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "20,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 3,
        productImg: product_02,
        itemName: "Filaments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "16,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 4,
        productImg: product_03,
        itemName: "FiA530laments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "9,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 5,
        productImg: product_04,
        itemName: "A530",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "8,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 6,
        productImg: ProductJpg,
        itemName: "Filaments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 7,
        productImg: product_03,
        itemName: "FiA530laments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 8,
        productImg: product_04,
        itemName: "A530",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
];

// 제품리스트 2
const ProductData2 = [
    {
        id: 0,
        productImg: ProductJpg,
        itemName: "Filaments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 1,
        productImg: ProductJpg,
        itemName: "Filaments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 2,
        productImg: product_01,
        itemName: "A530",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "20,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 3,
        productImg: product_02,
        itemName: "Filaments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "16,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 4,
        productImg: product_03,
        itemName: "FiA530laments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "9,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 5,
        productImg: product_04,
        itemName: "A530",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "8,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 6,
        productImg: ProductJpg,
        itemName: "Filaments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 7,
        productImg: product_03,
        itemName: "FiA530laments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 8,
        productImg: product_04,
        itemName: "A530",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
    {
        id: 9,
        productImg: ProductJpg,
        itemName: "Filaments",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        isDiscount: false,
        orginPrice: "10,000,000",
        percent: "10",
        price: "9,900,000",
    },
];

// 주문 리스트
const OrderListData = [
    {
        id: 0,
        date: "2021.12.13",
        ordernum: "28000120222041",
        orderlist: [
            {
                id: 0,
                productImg: ProductJpg,
                itemName: "type A530",
                price: "9,900,000",
                option: "[type A530 + smartStation™]",
                num: 1,
                delivery: "",
                state: 5,
            },
            {
                id: 1,
                productImg: product_01,
                itemName: "type B530",
                price: "19,900,000",
                option: "[type A530 + smartStation™]",
                num: 2,
                delivery: "2,500",
                state: 6,
            },
        ],
    },
    {
        id: 1,
        date: "2021.12.10",
        ordernum: "00000120222041",
        orderlist: [
            {
                id: 0,
                productImg: product_02,
                itemName: "type AC530",
                price: "900,000",
                option: "[type A530 + smartStation™]",
                num: 1,
                delivery: "",
                state: 7,
            },
            {
                id: 1,
                productImg: product_03,
                itemName: "type BA530",
                price: "1,900,000",
                option: "[type A530 + smartStation™]",
                num: 2,
                delivery: "2,500",
                state: 8,
            },
        ],
    },
    {
        id: 2,
        date: "2021.12.05",
        ordernum: "00001120222041",
        orderlist: [
            {
                id: 0,
                productImg: product_04,
                itemName: "type AC530",
                price: "900,000",
                option: "[type A530 + smartStation™]",
                num: 1,
                delivery: "",
                state: 9,
            },
        ],
    },
    {
        id: 3,
        date: "2021.12.04",
        ordernum: "00001120222041",
        orderlist: [
            {
                id: 0,
                productImg: ProductJpg,
                itemName: "type AC530",
                price: "900,000",
                option: "[type A530 + smartStation™]",
                num: 11,
                delivery: "",
                state: 1,
            },
        ],
    },
    {
        id: 0,
        date: "2021.12.13",
        ordernum: "28000120222041",
        orderlist: [
            {
                id: 0,
                productImg: ProductJpg,
                itemName: "type A530",
                price: "9,900,000",
                option: "[type A530 + smartStation™]",
                num: 1,
                delivery: "",
                state: 5,
            },
            {
                id: 1,
                productImg: product_01,
                itemName: "type B530",
                price: "19,900,000",
                option: "[type A530 + smartStation™]",
                num: 2,
                delivery: "2,500",
                state: 6,
            },
        ],
    },
];

// 문의 리스트 data
const qnaListData = [
    {
        id: 0,
        cate: "재입고문의",
        content: [
            <>
                안녕하세요. 재입고문의 드립니다. 혹시 언제쯤 재입고되는지 알 수 있을까요? 계속 기다리는 중인데...
                <br />
                문의 남겨드립니다.
            </>,
        ],
        date: "2012.12.20",
        imglist: [
            {
                id: "1",
                content: product_01,
            },
            {
                id: "2",
                content: product_02,
            },
        ],
        answer: [
            <>
                안녕하세요. type A530의 경우 현재 정확한 입고여부를 파악하기 어려워, 제대로 확답을 드리기 어렵습니다. 최대한 빠르게 재입고 될 수 있도록
                하겠습니다. 감사합니다.
            </>,
        ],
        answerdate: "2012.12.21",
    },
    {
        id: 1,
        cate: "상품문의",
        content: [
            <>
                안녕하세요. 재입고문의 드립니다. 혹시 언제쯤 재입고되는지 알 수 있을까요? 계속 기다리는 중인데...
                <br />
                문의 남겨드립니다.
            </>,
        ],
        date: "2012.11.20",
        answer: [
            <>
                안녕하세요. type A530의 경우 현재 정확한 입고여부를 파악하기 어려워, 제대로 확답을 드리기 어렵습니다. 최대한 빠르게 재입고 될 수 있도록
                하겠습니다. 감사합니다.
            </>,
        ],
        answerdate: "2012.11.21",
    },
    {
        id: 2,
        cate: "재입고문의",
        content: [
            <>
                안녕하세요. 재입고문의 드립니다. 혹시 언제쯤 재입고되는지 알 수 있을까요? 계속 기다리는 중인데...
                <br />
                문의 남겨드립니다.
            </>,
        ],
        date: "2012.11.20",
        imglist: [
            {
                id: "1",
                content: product_01,
            },
            {
                id: "2",
                content: product_02,
            },
        ],
    },
    {
        id: 3,
        cate: "배송문의",
        content: [
            <>
                안녕하세요. 재입고문의 드립니다. 혹시 언제쯤 재입고되는지 알 수 있을까요? 계속 기다리는 중인데...
                <br />
                문의 남겨드립니다.
            </>,
        ],
        date: "2012.10.20",
    },
    {
        id: 4,
        cate: "기타",
        content: [
            <>
                안녕하세요. 재입고문의 드립니다. 혹시 언제쯤 재입고되는지 알 수 있을까요? 계속 기다리는 중인데...
                <br />
                문의 남겨드립니다.
            </>,
        ],
        date: "2012.06.20",
        imglist: [
            {
                id: "1",
                content: product_01,
            },
            {
                id: "2",
                content: product_02,
            },
        ],
    },
    {
        id: 5,
        cate: "[재입고문의]",
        content: [
            <>
                안녕하세요. 재입고문의 드립니다. 혹시 언제쯤 재입고되는지 알 수 있을까요? 계속 기다리는 중인데...
                <br />
                문의 남겨드립니다.
            </>,
        ],
        date: "2012.04.20",
        answer: [
            <>
                안녕하세요. type A530의 경우 현재 정확한 입고여부를 파악하기 어려워, 제대로 확답을 드리기 어렵습니다. 최대한 빠르게 재입고 될 수 있도록
                하겠습니다. 감사합니다.
            </>,
        ],
        answerdate: "2012.04.21",
    },
    {
        id: 6,
        cate: "[상품문의]",
        content: [
            <>
                안녕하세요. 재입고문의 드립니다. 혹시 언제쯤 재입고되는지 알 수 있을까요? 계속 기다리는 중인데...
                <br />
                문의 남겨드립니다.
            </>,
        ],
        date: "2012.01.20",
        answer: [
            <>
                안녕하세요. type A530의 경우 현재 정확한 입고여부를 파악하기 어려워, 제대로 확답을 드리기 어렵습니다. 최대한 빠르게 재입고 될 수 있도록
                하겠습니다. 감사합니다.
            </>,
        ],
        answerdate: "2012.01.21",
    },
];

// 관련제품 리스트 data
const cartDataList = [
    {
        id: 1,
        productImg: ProductJpg,
        itemName: "type A530",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        option: "[type A530 + smartStation™]",
        isDiscount: true,
        orginPrice: "10,000,000",
        percent: "10%",
        discount: "8,000",
        price: "9,900,000",
        delivery: "2,500",
    },
    {
        id: 2,
        productImg: ProductJpg,
        itemName: "type A530",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        option: "[type A530 + smartStation™]",
        isDiscount: true,
        orginPrice: "10,000,000",
        percent: "10%",
        discount: "8,000",
        price: "9,900,000",
        delivery: "2,500",
    },
    {
        id: 3,
        productImg: ProductJpg,
        itemName: "type A530",
        desc: "[Description] 설명이 들어가는 장소입니다.",
        option: "[type A530 + smartStation™]",
        isDiscount: true,
        orginPrice: "10,000,000",
        percent: "10%",
        discount: "8,000",
        price: "9,900,000",
        delivery: "2,500",
    },
];

const orderStateDataList = [
    {
        date: "2021.12.23",
        num: "28000120222041",
        state: "취소",
        isItem: [
            {
                id: 1,
                productImg: product_01,
                itemName: "type A530",
                price: "9,900,000",
                option: "[type A530 + smartStation™]",
                num: 1,

                orderstate: "취소신청",
            },
        ],
    },
    {
        date: "2021.12.23",
        num: "28000120222041",
        state: "취소",
        isItem: [
            {
                id: 1,
                productImg: product_03,
                itemName: "type A530",
                price: "9,900,000",
                option: "[type A530 + smartStation™]",
                num: 1,

                orderstate: "취소완료",
            },
        ],
    },
    {
        date: "2021.12.23",
        num: "28000120222041",
        state: "교환",
        isItem: [
            {
                id: 1,
                productImg: product_04,
                itemName: "type A530",
                price: "9,900,000",
                option: "[type A530 + smartStation™]",
                num: 1,

                orderstate: "교환신청",
            },
        ],
    },
    {
        date: "2021.12.23",
        num: "28000120222041",
        state: "교환",
        isItem: [
            {
                id: 1,
                productImg: product_02,
                itemName: "type A530",
                price: "9,900,000",
                option: "[type A530 + smartStation™]",
                num: 1,

                orderstate: "교환완료",
            },
        ],
    },
    {
        date: "2021.12.23",
        num: "28000120222041",
        state: "반품",
        isItem: [
            {
                id: 1,
                productImg: product_03,
                itemName: "type A530",
                price: "9,900,000",
                option: "[type A530 + smartStation™]",
                num: 1,

                orderstate: "반품신청",
            },
        ],
    },
    {
        date: "2021.12.23",
        num: "28000120222041",
        state: "반품",
        isItem: [
            {
                id: 1,
                productImg: product_04,
                itemName: "type A530",
                price: "9,900,000",
                option: "[type A530 + smartStation™]",
                num: 1,

                orderstate: "반품완료",
            },
            {
                id: 1,
                productImg: product_04,
                itemName: "type A530",
                price: "9,900,000",
                option: "[type A530 + smartStation™]",
                num: 3,
                orderstate: "반품진행중",
            },
        ],
    },
];

export { ProductData, ProductData2, OrderListData, qnaListData, cartDataList, orderStateDataList };
